import { PrimaryBtn } from "../../../components";
import "./AboutTitlePara.scss";

const AboutTitlePara = ({tag, title, para}) => {
  const knowMore = () => {
    const section = document.getElementById("accodion");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }
    return(
        <section className="about_title_para p_t p_b">      
       
            <div className="content_wrap">
                <div className="text_content">
       
            <p className="tag_title darkGold">{tag}</p>
            <h3 className="darkGold" >
            {title}
            </h3>
            <p className="darkGold">
              {para}
            </p>
            <PrimaryBtn theme="gold" title="Know more" clickHandler={knowMore} />
            </div>
        </div>
      </section>
       
    )
}
export default AboutTitlePara;